import FileAttachments from '../../../../components/FileAttachments/FileAttachments';
import React from 'react';
import {Text} from '../../../../styled';

const Footer = ({ item }:any) => {
  const { gmail_account, att, date } = item;
  return (
    <>
      <FileAttachments files={att.filter((f:any) => f.isAttachment)} />
      <Text variant="muted" size="small" >
        {gmail_account} | {date || 'Not available'}
      </Text>
    </>
  )
}


export default Footer;